import React from 'react';
import { Paper } from '@mui/material';
import { Widget } from '@typeform/embed-react';
import { useQueryClient } from 'react-query';

import { getTypeformIdFromUrl, isTypeformUrl } from '../../../Utils/Post/study';
import FormIframe from './FormIframe';
import queriesConfig from '../../../Services/queriesConfig';

function FormEmbed({ post }: any) {
  const url = post.form_url;
  const isTypeform = isTypeformUrl(url);
  const queryClient = useQueryClient();

  if (!url) {
    return null;
  }

  // When the Form is from Typeform
  if (isTypeform) {
    const typeformId = getTypeformIdFromUrl(url);

    return (
      <Paper elevation={0} variant="outlined">
        <Widget
          id={typeformId}
          hidden={{ uuid: post.identity_uuid }}
          style={{ width: '100%', height: '100vh' }}
          onSubmit={() => {
            setTimeout(() => {
              // We need to invalidate the post query to update the post.has_answered to get the correct EmptyState
              queryClient.invalidateQueries(queriesConfig.getPost(post.id).queryKey);
            }, 5000);
          }}
        />
      </Paper>
    );
  }

  // When the Form is from other sources, we just render the URL in an iframe
  return <FormIframe title={post.title} url={url} />;
}

export default FormEmbed;
